module.exports = __webpack_public_path__ + "img/Diwali.d08d9a04.jpeg";